import axios from "axios";
import Swal from "sweetalert2";
import { tokenConfig } from "./websiteActions";
import { t } from "i18next";
import { arrayHierarchy } from "components/Function";

const getCategories = (callback = null, category_version = "v2") => (dispatch, getState) => {
    return axios
        .get(`/api/categories?version=${category_version || "v2"}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                if (callback) callback?.(res?.data.data?.categories || []);
                return arrayHierarchy(res?.data.data?.categories || []);
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

const getAttributes = (id, version = "v2") => (dispatch, getState) => {
    return axios
        .get(`/api/categories/attributes/${id}?version=${version}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};


const getBrands = (data) => (dispatch, getState) => {
    return axios
        .post(`/api/categories/brands`, data, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

const createBrands = (data) => async (dispatch, getState) => {
    return axios
        .post(`/api/categories/brands-create`, data, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                // Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            // Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

const getRecommendCategories = (callback = null, category_version = "v2", product_name = "", product_image = "") => (dispatch, getState) => {
    return axios
        .get(`/api/categories/recommend-categories?version=${category_version || "v2"}&product_name=${encodeURIComponent(product_name)}&product_image=${encodeURIComponent(product_image || "")}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                if (callback) callback?.(res?.data.data?.categories || []);
                return arrayHierarchy(res?.data.data?.categories || []);
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            console.log(err);
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

const suggestAttributeAI = ({ title, data, image, des }) => (dispatch, getState) => {
    if (!title) Swal.fire(t("Error"), t("Title is required!"), "error");
    if (!data) Swal.fire(t("Error"), t("Title is required!"), "error");
    if (!image) Swal.fire(t("Error"), t("Image is required!"), "error");
    if (!des) Swal.fire(t("Error"), t("Description is required!"), "error");
    return axios
        .post(`/api/ai/attribute`, { title, data, image, des }, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                try {
                    let result = JSON.parse(res.data?.data?.data);
                    const baseAttr = data.reduce((r, o) => {
                        r[o.id] = o;
                        return r;
                    }, {});
                    result = result.map((r) => {
                        const baseValue = baseAttr[r.id]?.values || [];
                        r.values = r.values.map((value) => {
                            const check = baseValue.find((b) => b.id === value.id);
                            if (!check) return { name: value.name || value.id };
                            return value;
                        })
                        return r;
                    });
                    return result;
                } catch {
                    return [];
                }
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export { getCategories, getAttributes, getBrands, getRecommendCategories, suggestAttributeAI, createBrands };
